<template>
  <component :is="currentComponent" v-if="ready"></component>
</template>

<script>
import MasterLayout from '../layouts/Master.vue';

export default {
  name: 'App',
  data() {
    return {
      ready: false,
      layout: null,
    };
  },
  components: {
    MasterLayout,
  },
  mounted() {
    this.setLayout(this.$route);
    this.ready = true;
  },
  watch: {
    $route(to) {
      this.setLayout(to);
    },
  },
  computed: {
    currentComponent() {
      return this.layout !== null ? `${this.layout}-layout` : 'router-view';
    },
  },
  methods: {
    setLayout(route) {
      this.layout = route.meta.layout || null;
    },
  },
};
</script>

<style lang="scss">
  @import "./src/assets/scss/_variables.scss";
  .page-container {
    margin: 0 auto;
    max-width: $control-width-xl;
    padding: $layout-spacing-lg;
  }
</style>
